module.exports = __webpack_public_path__ + "img/lungcancer.0109a09c.png";